import { forwardRef, useImperativeHandle, useState } from 'react';
import { Swiper } from 'antd-mobile';
import { SlideModal } from '@/components';
import { ossPrefix, storagePrefixV2 } from '@/constant';
import cx from './index.module.scss';

export interface QuickGuideModalRefAttrs {
  show: VoidFunc;
  hide: VoidFunc;
}

interface Props {}

const IMG_LIST = [
  ossPrefix + '/index_module/index/lysfcyer_897074.png',
  storagePrefixV2 + '/quick-guide-modal-bg-2.png',
];

const QuickGuide = forwardRef<QuickGuideModalRefAttrs, Props>((props, ref) => {
  const [open, setOpen] = useState(false);

  const toggleShow = (status: boolean) => {
    setOpen(status);
  };

  useImperativeHandle(
    ref,
    () => ({
      show: () => toggleShow(true),
      hide: () => toggleShow(false),
    }),
    []
  );

  return (
    <SlideModal className={cx('modal-wrapper')} open={open}>
      <div className={cx('modal-box')}>
        <div className={cx('title')}>
          <div>理疗机器人简易操作导览</div>
          <div className={cx('close-text')} onClick={() => setOpen(false)}>
            完成
          </div>
        </div>
        <div className={cx('swiper')}>
          <Swiper>
            {IMG_LIST.map((item, index) => (
              <Swiper.Item key={index}>
                <div className={cx('img-container')}>
                  <img key={index} src={item} alt="img" />
                </div>
              </Swiper.Item>
            ))}
          </Swiper>
        </div>
      </div>
    </SlideModal>
  );
});

export default QuickGuide;
